import { render, staticRenderFns } from "./trialBalanceBottom.vue?vue&type=template&id=2d6f6b19"
import script from "./trialBalanceBottom.vue?vue&type=script&lang=js"
export * from "./trialBalanceBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports